function NotFound() {
    return (
        <main>
            <h1>Info</h1>
            <h3>Leksehjelpen sine åpningstider:</h3>
            <ul>
                <li><b>Mandag: </b>13:30-16:30</li>
                <li><b>Tirsdag: </b>15:10-17:10</li>
            </ul>
            <br />
            <h3>Hvordan funker det?</h3>
            <ol>
                <li>Skann nærmeste leksehjelp QR-kode</li>
                <li>Velg fag</li>
                <li>Trykk på knappen: "Tilkall leksehjelp"</li>
                <li>Skjermen oppdateres når leksehjelp er på vei</li>
            </ol>
            <br />
            <p><i>(Endringer kan forekomme, men trolig ikke)</i></p>
            <p><i>(Nettsidesystemet er nytt og derfor muligens ustabilt. Dersom du du må vente for lenge, bare gå bort til leksehjelpen.)</i></p>
        </main>
    );
};

export default NotFound;